export class User {
    loggedIn = false;
    mobile = '';
    email = '';
    name = '';
    usertype = '';
    userid = '';
}
